import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateViewColumnV3 = OpalApi<'CreateViewColumnV3', 201>

export const createViewColumn: CreateViewColumnV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/view_columns', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
